function wcuInitAnimations(root) {
  var scope = root || document;
  var sections = scope.querySelectorAll('.wcu-section[data-animate="true"]');

  sections.forEach(function (section) {
    if (section.dataset.wcuInit === 'true') return; // avoid double-binding
    section.dataset.wcuInit = 'true';

    var targets = section.querySelectorAll('.wcu-animate');
    if (!('IntersectionObserver' in window) || !targets.length) {
      targets.forEach(function (el) { el.classList.add('wcu-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wcu-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  });
}

function wcuInitSlider(root) {
  var scope = root || document;
  var sections = scope.querySelectorAll('.wcu-mobile-slider');

  sections.forEach(function (section) {
    if (section.dataset.wcuSliderInit === 'true') return;
    section.dataset.wcuSliderInit = 'true';

    var grid = section.querySelector('.wcu-grid');
    var prev = section.querySelector('.wcu-slider-prev');
    var next = section.querySelector('.wcu-slider-next');
    if (!grid || !prev || !next) return;

    function step() {
      var card = grid.querySelector('.wcu-card');
      var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || 16);
      return card ? card.getBoundingClientRect().width + gap : 280;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      grid.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
}

function wcuInitAll(root) {
  wcuInitAnimations(root);
  wcuInitSlider(root);
}

// Normal storefront load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    wcuInitAll(document);
  });
} else {
  // DOM already parsed (e.g. script injected after initial load)
  wcuInitAll(document);
}

// Shopify theme editor: re-init whenever this section (or any section) is
// added/re-rendered via AJAX, since DOMContentLoaded won't fire again
document.addEventListener('shopify:section:load', function (event) {
  wcuInitAll(event.target);
});

// Also cover block select/deselect re-renders in some themes
document.addEventListener('shopify:block:select', function (event) {
  wcuInitAll(document);
});

// Safety net: force-reveal any animated element that hasn't appeared
// within 2s (covers edge cases like editor iframe visibility quirks)
setTimeout(function () {
  document.querySelectorAll('.wcu-animate:not(.wcu-in-view)').forEach(function (el) {
    el.classList.add('wcu-in-view');
  });
}, 2000);
